import publics from './public';
import users from './users'

export default {
    public: publics,
    users
}